import { render, staticRenderFns } from "./NuevoSindicato.vue?vue&type=template&id=9f6af974&"
import script from "./NuevoSindicato.vue?vue&type=script&lang=js&"
export * from "./NuevoSindicato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports